import { observer } from 'mobx-react-lite'
import { Activity, ChatPlusIn } from 'iconoir-react'
import { Link } from 'react-router-dom'
import { ActivityDrawer } from 'app/components/activities/ActivityDrawer'
import { Feature } from 'app/components/auth/Feature'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeader } from 'app/components/PageHeader'
import ExportRows from 'app/components/table/ExportRows'
import TableLayout from 'app/components/table/TableLayout'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import { useIsMobile } from 'app/hooks/useMediaQuery'
import { FilterObject } from 'app/filter.utils'
import type { UseActivitiesPageReturn } from './useActivitiesPage'

export type ActivitiesPageComponentProps = UseActivitiesPageReturn

export const ActivitiesPageComponent = observer(function ActivitiesPageComponent(props: ActivitiesPageComponentProps) {
  const { activities, columns, memoizedFilters, initialSort, drawer, loadActivity, data, pageTitle, searchTerms } =
    props
  const isMobile = useIsMobile()

  return (
    <PageScroll
      variant="table"
      header={
        <PageHeader
          title={pageTitle}
          totalItems={activities?.total}
          otherButtons={[
            <Feature key="1" name="TRK-2569">
              <Link
                to="/import"
                aria-label="Import"
                className={isMobile ? `btn btn-tertiary btn-sm` : `btn btn-primary btn-md`}
              >
                <ChatPlusIn className={isMobile ? `` : `mr-1`} /> {!isMobile && `Import`}
              </Link>
            </Feature>,
          ]}
        />
      }
    >
      <TableLayout
        key={data.tab}
        filterableColumns={memoizedFilters}
        extraButtons={(columns, columnVisibility) => [
          <ExportRows
            key={1}
            loaderPropertyName={`activities`}
            totalSize={activities?.total ?? 0}
            columns={columns}
            columnVisibility={columnVisibility}
            search={searchTerms}
          />,
        ]}
        defaultJoin={data.joiner}
        data={activities}
        columns={columns as any}
        initialSort={initialSort}
        initialFilters={data.initialFilters as FilterObject[]}
        meta={{ getRowStyle: (row) => (row?.id === drawer.focusedActivity?.id ? `table-selected-row` : ``) }}
        edgePadded
        emptyState={
          <TableEmptyState
            icon={<Activity className="h-6 w-6" strokeWidth={1.5} />}
            title="No activity yet"
            description="Every call, form submission, and message shows up here as it happens, with the contact and source attached."
          />
        }
      />
      <ActivityDrawer
        activity={drawer.focusedActivity}
        isLoading={drawer.isActivityLoading}
        open={drawer.openDrawer}
        onChange={loadActivity}
        onClose={drawer.closeDrawer}
      />
    </PageScroll>
  )
})
